module.exports = __webpack_public_path__ + "4b9a1a251f4ea713708c813dc49ca47f.pdf";